import { get } from "lodash";

export default {
  computed: {
    translations() {
      const TRANSLATIONS = get(window, "vueBridge.translations", {});

      return {
        // SHARED:
        next: TRANSLATIONS.next || "Next",
        // CERTIFICATE OF COMPLETION:
        certificateIntro:
          TRANSLATIONS.certificateIntro ||
          "This certificate is awarded for completion of SEE 101, the online orientation course consisting of 8 hours of training. Completion of this course qualifies the participant to implement the SEE Learning curricula in an educational setting.",
        certificateTitle: TRANSLATIONS.certificateTitle || "Certificate [[br]] of Completion",
        certificateFooter: TRANSLATIONS.certificateFooter || "Educating the [[br]] Heart [[amp]] Mind",
        date: TRANSLATIONS.date || "Date",
        name: TRANSLATIONS.name || "Name",
        print: TRANSLATIONS.print || "PRINT",
        // COURSE:
        begin: TRANSLATIONS.begin || "Begin",
        beginExercise: TRANSLATIONS.beginExercise || "Begin Exercise",
        closeAndContinue: TRANSLATIONS.closeAndContinue || "Close and Continue",
        continue: TRANSLATIONS.continue || "Continue",
        labelAddress: TRANSLATIONS.labelAddress || "Address:",
        labelName: TRANSLATIONS.labelName || "Name:",
        labelPosition: TRANSLATIONS.labelPosition || "Position:",
        labelSchoolAgency: TRANSLATIONS.labelSchoolAgency || "School/Agency:",
        levelOfModuleNumber: TRANSLATIONS.levelOfModuleNumber || "Level [[levelNumber]] of [[numLevels]]",
        levelTypeCompleted: TRANSLATIONS.levelTypeCompleted || "You have completed this [[levelType]]",
        likert1: TRANSLATIONS.likert1 || "Never",
        likert2: TRANSLATIONS.likert2 || "Rarely",
        likert3: TRANSLATIONS.likert3 || "Sometimes",
        likert4: TRANSLATIONS.likert4 || "Often",
        likert5: TRANSLATIONS.likert5 || "Very Often",
        loading: TRANSLATIONS.loading || "Loading...",
        moduleNumber: TRANSLATIONS.moduleNumber || "Module [[moduleNumber]]",
        nextLevel: TRANSLATIONS.nextLevel || "Next Level",
        playVideo: TRANSLATIONS.playVideo || "Play Video",
        previous: TRANSLATIONS.previous || "Previous",
        prioritizeChallengesLeastDesc: TRANSLATIONS.prioritizeChallengesLeastDesc || "least common and concerning",
        prioritizeChallengesMostDesc: TRANSLATIONS.prioritizeChallengesMostDesc || "most common and concerning",
        readMore: TRANSLATIONS.readMore || "Read More",
        startModule: TRANSLATIONS.startModule || "Start Module",
        startModuleNumber: TRANSLATIONS.startModuleNumber || "Start Module [[moduleNumber]]",
        submitAndContinue: TRANSLATIONS.submitAndContinue || "Submit and Continue",
        // STUDY CONSENT FORM:
        consentParticipation:
          TRANSLATIONS.consentParticipation || "[[startBold]]Yes[[endBold]], I consent to participate in this study",
        consentRecontact:
          TRANSLATIONS.consentRecontact ||
          "[[startBold]]Yes[[endBold]], you may recontact me in the future after the initial training is complete",
        // REGISTRATION/PROFILE PAGE:
        createAccount: TRANSLATIONS.createAccount || "Create Account",
        updateProfile: TRANSLATIONS.updateProfile || "Update Profile",
        profileLoading: TRANSLATIONS.profileLoading || "Loading profile data...",
        saving: TRANSLATIONS.saving || "Saving...",
        formSelectPlaceholder: TRANSLATIONS.formSelectPlaceholder || "Select",
        email: TRANSLATIONS.email || "Email",
        currentPassword: TRANSLATIONS.currentPassword || "Current Password",
        password: TRANSLATIONS.password || "Password",
        confirmPassword: TRANSLATIONS.confirmPassword || "Confirm Password",
        newPassword: TRANSLATIONS.newPassword || "New Password",
        confirmNewPassword: TRANSLATIONS.confirmNewPassword || "Confirm New Password",
        firstName: TRANSLATIONS.firstName || "First Name",
        middleName: TRANSLATIONS.middleName || "Middle",
        lastName: TRANSLATIONS.lastName || "Last Name",
        formLabelRole: TRANSLATIONS.formLabelRole || "Role in your organization/school",
        formValueRole1: TRANSLATIONS.formValueRole1 || "Director",
        formValueRole2: TRANSLATIONS.formValueRole2 || "Principal/Head of School",
        formValueRole3: TRANSLATIONS.formValueRole3 || "Other Type of Administrator",
        formValueRole4: TRANSLATIONS.formValueRole4 || "Teacher",
        formValueRole5: TRANSLATIONS.formValueRole5 || "School Counselor, psychologist or social worker",
        formValueRole6: TRANSLATIONS.formValueRole6 || "Not Applicable",
        formLabelAge: TRANSLATIONS.formLabelAge || "Age",
        formValueAgeRange1: TRANSLATIONS.formValueAgeRange1 || "18-24 years old",
        formValueAgeRange2: TRANSLATIONS.formValueAgeRange2 || "25-34 years old",
        formValueAgeRange3: TRANSLATIONS.formValueAgeRange3 || "35-44 years old",
        formValueAgeRange4: TRANSLATIONS.formValueAgeRange4 || "45-54 years old",
        formValueAgeRange5: TRANSLATIONS.formValueAgeRange5 || "55-64 years old",
        formValueAgeRange6: TRANSLATIONS.formValueAgeRange6 || "65 years or older",
        formLabelGender: TRANSLATIONS.formLabelGender || "Gender",
        formValueGender1: TRANSLATIONS.formValueGender1 || "Female",
        formValueGender2: TRANSLATIONS.formValueGender2 || "Male",
        formValueGender3: TRANSLATIONS.formValueGender3 || "Non-binary/third gender",
        formValueGender4: TRANSLATIONS.formValueGender4 || "Prefer to self-describe",
        formValueGender5: TRANSLATIONS.formValueGender5 || "Prefer not to say",
        formLabelOtherGender: TRANSLATIONS.formLabelOtherGender || "Self-Described Gender",
        formLabelCountry: TRANSLATIONS.formLabelCountry || "Country of your organization",
        formLabelRace: TRANSLATIONS.formLabelRace || "Race (if Country is USA)",
        formValueRace1: TRANSLATIONS.formValueRace1 || "Hispanic or Latin or Spanish Origin of any race",
        formValueRace2: TRANSLATIONS.formValueRace2 || "American Indian or Alaskan Native",
        formValueRace3: TRANSLATIONS.formValueRace3 || "Asian",
        formValueRace4: TRANSLATIONS.formValueRace4 || "Native Hawaiian or other pacific Islander",
        formValueRace5: TRANSLATIONS.formValueRace5 || "Black or African American",
        formValueRace6: TRANSLATIONS.formValueRace6 || "White",
        formValueRace7: TRANSLATIONS.formValueRace7 || "Race unknown",
        formValueRace8: TRANSLATIONS.formValueRace8 || "Prefer not to say",
        formLabelReferral: TRANSLATIONS.formLabelReferral || "How did you find out about this program?",
        formLabelEducation: TRANSLATIONS.formLabelEducation || "Education Level",
        formValueEducation1: TRANSLATIONS.formValueEducation1 || "No schooling completed",
        formValueEducation2:
          TRANSLATIONS.formValueEducation2 || "Some elementary level or equivalent but not completed",
        formValueEducation3:
          TRANSLATIONS.formValueEducation3 || "Some high school level or equivalent but not completed",
        formValueEducation4:
          TRANSLATIONS.formValueEducation4 ||
          "High school or equivalent completed (e.g., diploma or the equivalent received)",
        formValueEducation5: TRANSLATIONS.formValueEducation5 || "Some college credit, no degree",
        formValueEducation6: TRANSLATIONS.formValueEducation6 || "Trade/technical/vocational training",
        formValueEducation7: TRANSLATIONS.formValueEducation7 || "Associate degree",
        formValueEducation8: TRANSLATIONS.formValueEducation8 || "Bachelor's degree",
        formValueEducation9: TRANSLATIONS.formValueEducation9 || "Master's degree",
        formValueEducation10: TRANSLATIONS.formValueEducation10 || "Professional degree",
        formValueEducation11: TRANSLATIONS.formValueEducation11 || "Doctorate degree",
        formLabelStudentGrades:
          TRANSLATIONS.formLabelStudentGrades || "What is/are the grade levels of the students you work with?",
        formValueStudentGrades1: TRANSLATIONS.formValueStudentGrades1 || "Pre-school",
        formValueStudentGrades2: TRANSLATIONS.formValueStudentGrades2 || "Kindergarten or equivalent",
        formValueStudentGrades3: TRANSLATIONS.formValueStudentGrades3 || "Grade 1",
        formValueStudentGrades4: TRANSLATIONS.formValueStudentGrades4 || "Grade 2",
        formValueStudentGrades5: TRANSLATIONS.formValueStudentGrades5 || "Grade 3",
        formValueStudentGrades6: TRANSLATIONS.formValueStudentGrades6 || "Grade 4",
        formValueStudentGrades7: TRANSLATIONS.formValueStudentGrades7 || "Grade 5",
        formValueStudentGrades8: TRANSLATIONS.formValueStudentGrades8 || "Grade 6",
        formValueStudentGrades9: TRANSLATIONS.formValueStudentGrades9 || "Grade 7",
        formValueStudentGrades10: TRANSLATIONS.formValueStudentGrades10 || "Grade 8",
        formValueStudentGrades11: TRANSLATIONS.formValueStudentGrades11 || "High School",
        formValueStudentGrades12: TRANSLATIONS.formValueStudentGrades12 || "District-wide",
        formValueStudentGrades13: TRANSLATIONS.formValueStudentGrades13 || "Not Applicable",
        formLabelStudentAges:
          TRANSLATIONS.formLabelStudentAges || "What is (are) the age(s) of the students you work with?",
        formValueStudentAges1: TRANSLATIONS.formValueStudentAges1 || "< 5",
        formValueStudentAges2: TRANSLATIONS.formValueStudentAges2 || "5 - 7",
        formValueStudentAges3: TRANSLATIONS.formValueStudentAges3 || "8 - 11",
        formValueStudentAges4: TRANSLATIONS.formValueStudentAges4 || "12 - 14",
        formValueStudentAges5: TRANSLATIONS.formValueStudentAges5 || "15 - 17",
        formValueStudentAges6: TRANSLATIONS.formValueStudentAges6 || "> 17",
        formValueStudentAges7: TRANSLATIONS.formValueStudentAges7 || "All Ages",
        formLabelYearsExperience:
          TRANSLATIONS.formLabelYearsExperience ||
          "How many years have you been working in education or in the field of youth development?",
        formValueYearsExperience1: TRANSLATIONS.formValueYearsExperience1 || "0-2 years",
        formValueYearsExperience2: TRANSLATIONS.formValueYearsExperience2 || "3-5 years",
        formValueYearsExperience3: TRANSLATIONS.formValueYearsExperience3 || "6-10 years",
        formValueYearsExperience4: TRANSLATIONS.formValueYearsExperience4 || "11-20 years",
        formValueYearsExperience5: TRANSLATIONS.formValueYearsExperience5 || "21-30 years",
        formValueYearsExperience6: TRANSLATIONS.formValueYearsExperience6 || "30+ years",
        formValueYearsExperience7: TRANSLATIONS.formValueYearsExperience7 || "Not Applicable",
        formLabelAffiliation:
          TRANSLATIONS.formLabelAffiliation || "What school(s) or educational organization(s) are you affiliated with?",
        formLabelSchoolType:
          TRANSLATIONS.formLabelSchoolType || "How would you describe your educational institution or organization?",
        formValueSchoolType1: TRANSLATIONS.formValueSchoolType1 || "Public School",
        formValueSchoolType2: TRANSLATIONS.formValueSchoolType2 || "Private School",
        formValueSchoolType3: TRANSLATIONS.formValueSchoolType3 || "Charter School",
        formValueSchoolType4: TRANSLATIONS.formValueSchoolType4 || "Independent School",
        formValueSchoolType5: TRANSLATIONS.formValueSchoolType5 || "Religious School",
        formValueSchoolType6: TRANSLATIONS.formValueSchoolType6 || "After School program",
        formValueSchoolType7: TRANSLATIONS.formValueSchoolType7 || "Summer/Vacation program",
        formValueSchoolType8: TRANSLATIONS.formValueSchoolType8 || "Governmental organization",
        formValueSchoolType9: TRANSLATIONS.formValueSchoolType9 || "Non-governmental organization",
        formValueSchoolType10: TRANSLATIONS.formValueSchoolType10 || "Social service organization",
        formValueSchoolType11: TRANSLATIONS.formValueSchoolType11 || "College/University",
        formValueSchoolType12: TRANSLATIONS.formValueSchoolType12 || "Independent program not affiliated with a school",
        formValueSchoolType13: TRANSLATIONS.formValueSchoolType13 || "Not Applicable",
        formLabelSchoolTypeOther: TRANSLATIONS.formLabelSchoolTypeOther || "Describe the independent program",
        formSectionSchoolDetails: TRANSLATIONS.formSectionSchoolDetails || "School or Organizational Details",
        formLabelSchoolAddress1: TRANSLATIONS.formLabelSchoolAddress1 || "School/Organization Address Line 1",
        formLabelSchoolAddress2: TRANSLATIONS.formLabelSchoolAddress2 || "School/Organization Address Line 2",
        formLabelSchoolCity: TRANSLATIONS.formLabelSchoolCity || "City",
        formLabelSchoolState: TRANSLATIONS.formLabelSchoolState || "State/Province/Region",
        formLabelSchoolDistrict: TRANSLATIONS.formLabelSchoolDistrict || "District",
        formLabelSchoolPhone: TRANSLATIONS.formLabelSchoolPhone || "Land Line Number for Organization Contact",
        formLabelSchoolContact: TRANSLATIONS.formLabelSchoolContact || "Mobile Phone for Organization Contact",
        formLabelSchoolEmail: TRANSLATIONS.formLabelSchoolEmail || "Email for Organization Contact",
        formSectionPastExperience: TRANSLATIONS.formSectionPastExperience || "Past Experience",
        formLabelExpTraining:
          TRANSLATIONS.formLabelExpTraining ||
          "Prior to this workshop, have you ever received training on programs that cultivate social, emotional, and/or ethical development in the classroom?",
        formValueExpTraining1: TRANSLATIONS.formValueExpTraining1 || "Yes",
        formValueExpTraining2: TRANSLATIONS.formValueExpTraining2 || "No",
        formLabelExpPrograms:
          TRANSLATIONS.formLabelExpPrograms ||
          "What is (are) the name(s) of the program(s) you were previously trained in prior to this orientation?",
        formRegistrationErrorText:
          TRANSLATIONS.formRegistrationErrorText ||
          "There was a problem with your submission. Please scroll up and fix the errors.",
        formProfileErrorText:
          TRANSLATIONS.formProfileErrorText || "There was an error saving your profile data. Please try again later.",
      };
    },
  },
};
